import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../components/forms/TextField';

export const EmailInputComponent = React.forwardRef(({
  hasError,
  helperText,
  onBlur,
  onChange,
  themeType,
  value,
}, ref) => (
  <TextField
    hasError={hasError}
    helperText={helperText}
    id='in-page-lead-form-email-input'
    labelText='Email'
    maxLength={200}
    name='email'
    onChange={onChange}
    onBlur={onBlur}
    ref={ref}
    required={true}
    themeType={themeType}
    value={value} />
));

EmailInputComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default EmailInputComponent;
